<ngx-spinner [fullScreen]="false" size="medium" bdColor="rgba(255, 255, 255, 0.9)" template="<svg  class='loader_circle_1 mx-auto d-block' width='80' height='80' viewBox='0 0 60 60' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g id='loader_19'>
    <g id='Group 8'>
    <rect id='Rectangle 154' x='25.0015' y='0.00012207' width='10' height='10' fill='#165c88'/>
    <rect id='Rectangle 161' x='28.001' y='52.9999' width='4' height='4' fill='#77abcc'/>
    <rect id='Rectangle 156' x='11.354' y='6.70215' width='9' height='9' transform='rotate(-30 11.354 6.70215)' fill='#196899'/>
    <rect id='Rectangle 162' x='40.4521' y='51.1016' width='3' height='3' transform='rotate(-30 40.4521 51.1016)' fill='#8eb9d5'/>
    <rect id='Rectangle 157' x='2.88672' y='18.9639' width='8' height='8' transform='rotate(-60 2.88672 18.9639)' fill='#1c73aa'/>
    <rect id='Rectangle 163' x='50.2856' y='42.8661' width='2' height='2' transform='rotate(-60 50.2856 42.8661)' fill='#a4c7dd'/>
    <rect id='Rectangle 160' x='16.5864' y='48.2354' width='5' height='5' transform='rotate(30 16.5864 48.2354)' fill='#609dc4'/>
    <rect id='Rectangle 159' x='9.44873' y='38.4025' width='6' height='6' transform='rotate(60 9.44873 38.4025)' fill='#498fbb'/>
    <rect id='Rectangle 158' x='1.50098' y='33.5' width='7' height='7' transform='rotate(-90 1.50098 33.5)' fill='#3381b3'/>
    <rect id='Rectangle 164' x='54.5015' y='30.5' width='1' height='1' transform='rotate(-90 54.5015 30.5)' fill='#bbd5e6'/>
    </g>
    </g>
</svg>">
    <p style="font-size: 18px; color: #1c73aa;margin-top:15px;font-weight: 600;">{{message}}</p>
</ngx-spinner>
<!-- BLue color shade
10 - 165c88
09 - 196899
08 - 1c73aa
07 - 3381b3
06 - 498fbb
05 - 609dc4
04 - 77abcc
03 - 8eb9d5
02 - a4c7dd
01 - bbd5e6
00 - d2e3ee -->